module.exports = __webpack_public_path__ + "static/media/Sade.7412634c.jpeg";